import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'jep-dashboard-layout',
	templateUrl: './dashboard-layout.component.html',
	styleUrls: ['./dashboard-layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DashboardLayoutComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
